import { categoryZones, navLinks } from "@/mocks/home";

export default function Footer() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-primary-900 text-primary-50">
      <div className="mx-auto max-w-page px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-800 text-lg">
                <i className="ri-play-fill" />
              </span>
              <span className="font-num text-lg font-extrabold tracking-tight">
                51<span className="text-primary-200">视频</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100/85">
              51视频主播内容导览页，汇集主播直播回放、网红福利视频合辑与主播动态，帮助你在一个页面里快速定位想看的内容。页面仅做内容整理与聚合展示。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["回放索引", "合辑精选", "主播榜单", "动态同步"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-primary-100/30 px-3 py-1 text-xs text-primary-100/90"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-primary-50">页面导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      jump(link.id);
                    }}
                    className="text-sm text-primary-100/80 transition-colors hover:text-primary-50 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-semibold text-primary-50">热门分类</h3>
            <div className="mt-4 grid grid-cols-2 gap-2.5">
              {categoryZones.map((zone) => (
                <a
                  key={zone.id}
                  href="#category"
                  onClick={(e) => {
                    e.preventDefault();
                    jump("category");
                  }}
                  className="flex items-center gap-2 text-sm text-primary-100/80 transition-colors hover:text-primary-50 cursor-pointer"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={zone.icon} />
                  </span>
                  {zone.name}专区
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-100/20 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-100/70">
            © {new Date().getFullYear()} 51视频 内容导览页 · 本页内容为聚合整理展示
          </p>
          <p className="text-xs text-primary-100/70">
            页面数据为整理示例，具体内容以主播实际发布为准
          </p>
        </div>
      </div>
    </footer>
  );
}